import { NOTIFICATION_TYPES } from "../getStockPageSectionFromNotificationType";

export const TREND_NOTIFICATION_TYPES = [
  NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND
];
